// @flow

import React from 'react';
import styled from 'styled-components';
import { Button, Tooltip, Position } from '@blueprintjs/core';

type Props = {
  count: number,
  total: number,
  canBulkAdd: boolean,
  canBulkRemove: boolean,
  addLabel?: string,
  removeLabel?: string,
  addDisabledTooltip?: string,
  removeDisabledTooltip?: string,
  onAdd: () => void,
  onRemove: () => void,
  onClear: () => void,
  onSelectAll: () => void,
};

const Bar = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 14px;
  border-radius: 4px;
  background: #137cbd;
  color: white;
  margin-bottom: 12px;
`;

const Count = styled.span`
  font-weight: 600;
`;

const Spacer = styled.span`
  flex: 1;
`;

const SelectAll = styled.button`
  border: none;
  background: transparent;
  color: white;
  text-decoration: underline;
  cursor: pointer;
  font-size: 12px;
  padding: 0;
  &:hover {
    opacity: 0.85;
  }
`;

const CategorizedBulkBar = ({
  count,
  total,
  canBulkAdd,
  canBulkRemove,
  addLabel = 'Add',
  removeLabel = 'Remove',
  addDisabledTooltip,
  removeDisabledTooltip,
  onAdd,
  onRemove,
  onClear,
  onSelectAll,
}: Props) => {
  if (count === 0) return null;

  const addButton = (
    <Button
      icon="plus"
      text={addLabel}
      disabled={!canBulkAdd}
      onClick={onAdd}
    />
  );
  const removeButton = (
    <Button
      icon="cross"
      text={removeLabel}
      disabled={!canBulkRemove}
      onClick={onRemove}
    />
  );

  return (
    <Bar>
      <Count>{count} selected</Count>
      {count < total && (
        <SelectAll type="button" onClick={onSelectAll}>
          Select all {total}
        </SelectAll>
      )}
      <Spacer />
      {canBulkAdd ? (
        addButton
      ) : (
        <Tooltip
          content={addDisabledTooltip || ''}
          position={Position.BOTTOM}
          disabled={!addDisabledTooltip}
        >
          {addButton}
        </Tooltip>
      )}
      {canBulkRemove ? (
        removeButton
      ) : (
        <Tooltip
          content={removeDisabledTooltip || ''}
          position={Position.BOTTOM}
          disabled={!removeDisabledTooltip}
        >
          {removeButton}
        </Tooltip>
      )}
      <Button minimal icon="cross" onClick={onClear} title="Clear selection" />
    </Bar>
  );
};

export default CategorizedBulkBar;
